export default {
  data() {
    return {
      billingTickets: {
        loading: false,
        pagination: {
          page: 1,
          perPage: 10,
          total: 0,
          totalPages: 0,
        },
        details: {},
        list: [],
        filters: {
          users: {
            list: [],
            selected: [],
          },
          status: {
            list: [
              {
                label: "Ativo",
                value: "Ativo",
              },
              {
                label: "Desativado",
                value: "Desativado",
              },
            ],
            selected: [],
          },
          period: {
            selected: [],
          },
          searchTerm: "",
          order: "desc",
          orderBy: "created",
        },
      },
    };
  },
  methods: {
    changeBillingTicketsPage(current) {
      this.billingTickets.pagination.page = current;
      this.getBillingTickets();
    },
    changeBillingTicketsPageSize(current, pageSize) {
      this.billingTickets.pagination.page = current;
      this.billingTickets.pagination.perPage = pageSize;
      this.getBillingTickets();
    },
    billingTicketsTableChange(pagination, filters, sorter) {
      filters;
      pagination;
      this.billingTickets.filters.order =
        sorter.order != undefined ? sorter.order : "desc";
      this.billingTickets.filters.orderBy =
        sorter.column != undefined ? sorter.column.key : "created";
      this.getBillingTickets();
    },
    getBillingTickets(samePage) {
      let filters = "";

      this.billingTickets.loading = true;

      if (this.billingTickets.filters.searchTerm) {
        filters += `&s=${this.billingTickets.filters.searchTerm}`;
      }

      if (this.billingTickets.filters.status.selected.length > 0) {
        filters += `&status=${this.billingTickets.filters.status.selected}`;
      }

      if (this.billingTickets.filters.users.selected.length > 0) {
        filters += `&user_id=${this.billingTickets.filters.users.selected}`;
      }

      filters += `&order=${this.billingTickets.filters.order}&order-by=${this.billingTickets.filters.orderBy}`;

      this.$http
        .get(
          `/billing-ticket/list?page=${this.billingTickets.pagination.page}&per_page=${this.billingTickets.pagination.perPage}${filters}`
        )
        .then(({ data }) => {
          if (!samePage) {
            this.billingTickets.pagination.page = 1;
          }
          this.billingTickets.pagination.total = data.meta.total;
          this.billingTickets.pagination.totalPages = data.meta.total_pages;
          this.billingTickets.list = data.data;
          this.billingTickets.loading = false;
        })
        .catch(({ response }) => {
          this.billingTickets.loading = false;
          this.billingTickets.list = response.data.data;
          this.billingTickets.pagination.total = response.data.meta.total;
          this.billingTickets.pagination.totalPages =
            response.data.meta.total_pages;
        });
    },
  },
};
